import axios from "axios";
import {AG_GRID_LOCALE_IT} from "./dictionary/agGridLocale_it";
import {AG_GRID_LOCALE_EN} from "./dictionary/agGridLocale_en";
import {AG_GRID_LOCALE_FR} from "./dictionary/agGridLocale_fr";
import i18n from "i18next";
import gitVersion from "../generatedGitInfo.json";
import {useQuery} from "@tanstack/react-query";
import {useUserActions} from "../stream/authentication/service/user.actions";
import {useContext, useLayoutEffect, useState} from "react";
import {GlobalContext} from "../util/state/GlobalContextProvider";
import {LicenseManager} from "ag-grid-enterprise";
import {setDialog, setSnackbar} from "../util/state/globalAction";
import {dialogTypes, snackbarTypes} from "../util/state/globalVariables";

export const useGitCheckLogVersion = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.get("gitVersion") !== null && console.log("gitVersion", gitVersion);
}

export const useAxiosDefaultConfig = () => {
    const {logout} = useUserActions();
    const pathOrigin = window.location.href;
    const {dispatchGlobalData} = useContext(GlobalContext);
    axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}`;
    axios.defaults.withCredentials = true;
    axios.interceptors.response.use((response) => {
        return response;
    }, error => {
        if (error && error.response && 401 === error.response.status) {
            //@ts-ignore
            const logoutOrigins = [`${window?.appConfig?.HOMEPAGE_ORIGIN}/`, `${window?.appConfig?.HOMEPAGE_ORIGIN}/login`, `${window?.appConfig?.ADFS_ORIGIN}/`, `${window?.appConfig?.ADFS_ORIGIN}/login`, `${window?.appConfig?.ADFS_INTRA_ORIGIN}/`, `${window?.appConfig?.ADFS_INTRA_ORIGIN}/login`];
            if (logoutOrigins.includes(pathOrigin)) {
                logout();
            } else if (!window.location.href.endsWith("sessionExpired")) {
                window.location.href = "/sessionExpired"
            }
        } else if (error && error.response && 403 === error.response.status) {
            dispatchGlobalData({
                type: setDialog,
                payload: {
                    dialog: dialogTypes.forbidden
                }
            });
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    })
}

export const logErrorToBe = (error: any) => {
    if (error?.config?.url !== '/log/error-fe') {
        axios.post('/log/error-fe', {
            error: JSON.stringify(error)
        }).then(res => console.log(res))
            .catch(err => console.log(err));
    }
}

export const useAgGridLocale = () => {
    switch (i18n.resolvedLanguage) {
        case 'fr':
        case 'fr-FR':
            return AG_GRID_LOCALE_FR;
        case 'it':
        case 'it-IT':
            return AG_GRID_LOCALE_IT;
        case 'en':
        default:
            return AG_GRID_LOCALE_EN;
    }
}

export const useCheckSession = () => {
    const check = () => axios.get('/checkSession');
    useQuery(['checkSession'], check, {
        refetchOnWindowFocus: true,
    });
}

export const useWindowSize = () => {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    useLayoutEffect(() => {
        function updateSize() {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export const useHasScope = (scope: string) => {
    const { globalData } = useContext(GlobalContext);
    return globalData?.user?.profiles?.some((profile:any) =>
        profile.auths.some((auth:any) => auth.name === scope)
    );
}
export const useHasScopes = (scopes: string[]) => {
    const { globalData } = useContext(GlobalContext);
    return globalData?.user?.profiles?.some((profile: any) =>
        profile.auths.some((auth: any) => scopes.includes(auth.name))
    ) ?? false; // Ritorna `false` se `globalData` è undefined/null
};


export const useSetAgGrid = () => {
    LicenseManager.setLicenseKey(`${process.env.REACT_APP_AG_GRID_LICENCE_KEY}`);
}
